module.exports = __webpack_public_path__ + "static/pruning-af7cc1b51a6c010abdc5458e3b5bbc44.png";